import { show, hide } from '../../../util/show';
const rssToggleSelector = '.js-podcast_activated_checkbox';
const spotifyToggleSelector = '.js-publish_on_spotify_checkbox';
const spotifyPlansErrorSelector = '.js-spotify_plans_error';
const spotifyPlansContainerSelector = '.js-spotify_plans_container';
const forceDisableSpotifyCheckboxSelector = "[data-force-disabled='true']";
const updateSpotifyPlansContainerVisibility = (spotifyToggle) => {
    const spotifyPlansContainer = document.querySelector(spotifyPlansContainerSelector);
    const hasSpotifyPlansError = !!document.querySelector(spotifyPlansErrorSelector);
    if (spotifyPlansContainer) {
        if (spotifyToggle.checked || hasSpotifyPlansError) {
            show(spotifyPlansContainer);
        }
        else {
            hide(spotifyPlansContainer);
        }
    }
};
const updateSpotifyToggle = (rssToggle) => {
    const spotifyToggle = document.querySelector(spotifyToggleSelector);
    const hasSpotifyPlansError = !!document.querySelector(spotifyPlansErrorSelector);
    const forceDisableSpotifyCheckbox = !!document.querySelector(forceDisableSpotifyCheckboxSelector);
    if (spotifyToggle) {
        if (rssToggle.checked || hasSpotifyPlansError) {
            spotifyToggle.removeAttribute('disabled');
        }
        else {
            spotifyToggle.setAttribute('disabled', 'disabled');
            spotifyToggle.checked = false;
        }
        if (forceDisableSpotifyCheckbox) {
            spotifyToggle.setAttribute('disabled', 'disabled');
        }
        updateSpotifyPlansContainerVisibility(spotifyToggle);
    }
};
window.up.compiler(rssToggleSelector, (rssToggle) => {
    updateSpotifyToggle(rssToggle);
    rssToggle.addEventListener('change', function () {
        updateSpotifyToggle(rssToggle);
    });
});
window.up.compiler(spotifyToggleSelector, (spotifyToggle) => {
    updateSpotifyPlansContainerVisibility(spotifyToggle);
    spotifyToggle.addEventListener('change', function () {
        updateSpotifyPlansContainerVisibility(spotifyToggle);
    });
});
